import React, { useEffect, useState } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import AdminNav from "../components/adminNav";
import Time from "../components/time";
import { useParams, Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const TyreVehicleSearch = () => {
  useAuthRedirect();
  const { id } = useParams(); 
  const [vehicleResult, setVehicle] = useState([]);
  const branch = localStorage.getItem("branch"); // Default branch from storage
  const navigate = useNavigate();
  const [header, setHeader] = useState({});
  const [totalCombined, setTotalCombined] = useState(0);
const [totKm, setTotKm] = useState(0);
const [vehicleBasis, setVehicleBasis] = useState(""); // "Hour" or other

const canView  = hasPermission("Tyre Maitenance Report", "view");



 

// Vehicle Bottom Details + Cumulative Fetch
useEffect(() => {
  const fetchVehicleDetails = async () => {
    Swal.fire({
      title: "Fetching Vehicle Details...",
      html: `
        <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
          <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
        </div>
        <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch vehicle and cumulative details...</p>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        const style = document.createElement("style");
        style.innerHTML = `
          @keyframes progressBar {
            0% { width: 0% }
            50% { width: 100% }
            100% { width: 0% }
          }
        `;
        document.head.appendChild(style);
      }
    });

    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/vehicleCurrentStatus_bottomDetails/${id}`);
      const vehicles = response.data.vehicles;
      setVehicle(vehicles);

      if (vehicles.length > 0 && vehicles[0].tyre_vehicle) {
        const tyreVehicleCode = vehicles[0].tyre_vehicle;

        try {
          const res = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_veh_TyreMain_cumulative_api?vcode=${tyreVehicleCode}`);
          const data = res.data?.cumulativeHrs?.[0];
          if (data) {
            setTotalCombined(data.total_combined || 0);
            setTotKm(data.tot_km || 0);
            setVehicleBasis(data.vehicle_basis || "");
          }
        } catch (err) {
          console.error("Error calling second API:", err);
        }
      }
    } catch (error) {
      console.error("Error fetching vehicle details:", error);
    } finally {
      Swal.close();
    }
  };

  {canView && (
  fetchVehicleDetails()
  )}
}, [id]);

// Header Details
useEffect(() => {
  const fetchIndentDetails = async () => {
    Swal.fire({
      title: "Fetching Header Details...",
      html: `
        <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
          <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
        </div>
        <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch header details...</p>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        const style = document.createElement("style");
        style.innerHTML = `
          @keyframes progressBar {
            0% { width: 0% }
            50% { width: 100% }
            100% { width: 0% }
          }
        `;
        document.head.appendChild(style);
      }
    });

    try {
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/vehicleCurrentStatus_headerDetails?id=${id}&branch=${branch}`);
      if (response.data && response.data.headerDetails?.length > 0) {
        const items = response.data.headerDetails;
        const storeReqHeader = {
          vehicle_basis: items[0].vehicle_basis || "N/A",
          vehicle_code: items[0].vehicle_code || "N/A",
          vehicle_type: items[0].vehicle_type || "N/A",
          vehicle_name: items[0].vehicle_name || "N/A",
        };
        setHeader(storeReqHeader);
      }
    } catch (error) {
      console.error("Error fetching locations:", error);
    } finally {
      Swal.close();
    }
  };

  {canView && (
  fetchIndentDetails()
  )}
}, [id, branch]);

//   useEffect(() => {
//     const fetchCumTot = async () => {
//       try {
//         const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/get_veh_detail1_cumulative_api?vcode=${id}`);
//         if (response.data && response.data.cumulativeHrs?.length > 0) {
//             const items = response.data.cumulativeHrs;

//             const storeReqHeader = {
//                 total_combined: items[0].total_combined || "N/A",
//             };

//             setCum(storeReqHeader);
//         }
//       } catch (error) {
//         console.error("Error fetching locations:", error);
//       }
//     };

//     fetchCumTot();
//   }, [id]); 

if (!canView) {
    return (
      <div id="admin-container">
        <AdminNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <AdminNav />
      <div className="content-right">
        <section>
          
            <div className="back-div">
                      <h2 className="add-txt">Vehicle To Tyre</h2>
                      <Link to={`/vehicle_currentStatus`}><p className="back-button"><i className="fa-solid fa-backward"></i> Back</p></Link>
                      </div>
          <div>
            <Time />
          </div>
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
            <div className="form-row">
              <div className="form-group">
                <label>Vehicle Code :</label>
                <input type="text" name="tyre_type" value={header.vehicle_code} readOnly/>

              </div>
              <div className="form-group">
                <label>Vehicle Name :</label>
                <input type="text" name="tyre_seriolno" value={header.vehicle_name} readOnly/>
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Vehicle Type :</label>
                <input type="text" name="tyre_model" value={header.vehicle_type} readOnly />
              </div>
              <div className="form-group">
                <label>Vehicle Basis :</label>
                <input type="text" name="vehicle_basis" value={header.vehicle_basis} readOnly />
              </div>
            </div> 
                    
            <div className="content-table">
            <table>
  <thead>
    <tr>
      <th>S.No</th>
      <th>Tyre No</th>
      <th>Branch</th>
      <th>Original/RTD</th>
      <th>Fitting Date</th>
      <th>Fitting Hrs/Km</th>
      <th>Running Km/Hrs</th>
      <th>Rate</th>
      <th>Tyre Cost Km/Hrs</th>
      <th>Remarks</th>
    </tr>
  </thead>
  <tbody>
  {vehicleResult.length > 0 ? (
    vehicleResult.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.tyre_seriolno}</td>
        <td>{item.tyre_branch}</td>
        <td>{item.tyre_type}</td>
        <td>{new Date(item.fitting_date).toLocaleDateString()}</td>
        <td>{item.fitting_km}</td>
        <td>
          {vehicleBasis === "Hour"
            ? totalCombined.toFixed(2)
            : totKm.toFixed(2)}
        </td>
        <td>{item.tyre_amount}</td>
        <td>{item.tyre_amount}</td>
        <td>{item.tyre_remarks}</td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="10">No Data Available</td>
    </tr>
  )}
</tbody>

</table>
            </div>
          </form>
        </div>

      
      </div>
    </div>
  );
};

export default TyreVehicleSearch;
